
import { useState } from 'react';
import noop from 'shared/lib/noop';
import { HTTP_REQUEST_ABORTED } from 'shared/constants';

export default ({ apiClient }) => {
  const [progress, setProgress] = useState(0);
  const [abort, setAbort] = useState({ callback: noop });

  const abortUpload = () => {
    if (abort.callback) {
      abort.callback();
      setProgress(0);
      setAbort({ callback: noop });
    }
  };

  const uploadFile = async (file) => {
    setProgress(0);
    setAbort({ callback: noop });

    try {
      const result = await apiClient.post(
        '/upload/file', {}, {}, [{ name: file.name, file }],
        ({ percent }) => setProgress(Math.min(Math.ceil(percent), 100)),
        callback => setAbort({ callback })
      );

      return result;
    } catch (err) {
      if (err.status !== HTTP_REQUEST_ABORTED) {
        throw err;
      }
    }

    return null;
  };

  return {
    uploadFile,
    progress,
    abortUpload,
  };
};
